import { CartContext } from "../../contexts/CartContext";
import Content from "../../content";
import ContentfulClient from "../../lib/contentful_client/ContentfulClient";
import FoundryPhysicalProduct from "../../lib/foundry_client/models/FoundryPhysicalProduct";
import Head from "next/head";
import { PageFadeWrapper } from "../../components/PageWrapper";
import ReviewCart from "../../components/cart/ReviewCart";
import ShoppingHeader from "../../components/cart/ShoppingHeader";
import WithCart from "../../components/cart/WithCart";
import { useContext } from "react";
import usePhysicalProducts from "../../hooks/usePhysicalProducts";

function CartIndex() {
  const { cartDetails } = useContext(CartContext);
  usePhysicalProducts();

  return (
    <>
      <Head>
        <title>Your Cart | {Content.siteName}</title>
      </Head>
      <PageFadeWrapper>
        <ShoppingHeader title="Your Cart" />
        <section className="container-wide w-full flex flex-col pb-24">
          {cartDetails && cartDetails.itemCount() > 0 ? (
            <WithCart onlyShowTotals={true} action="checkout">
              <ReviewCart cart={cartDetails} />
            </WithCart>
          ) : (
            <section className="flex items-center justify-center self-center mt-24 p-12 border rounded">
              <p>Your cart is empty.</p>
            </section>
          )}
        </section>
      </PageFadeWrapper>
    </>
  );
}

CartIndex.displayName = "CartIndex";
export default CartIndex;
